import React from "react";
import PillarFormLoadingButton from "shared/components/pillar-form/components/PillarFormLoadingButton";
import PillarTableErrorMessage from "shared/components/pillar-table/error/PillarTableErrorMessage";
import { usePillarTableContext } from "shared/components/pillar-table/PillarTableContext";

/**
 * The row a table shows when its `dataQuery` failed.
 *
 * The message is whatever `handleError` decided this caller may see, so it is
 * safe to print as-is: a member gets the public half, an admin or a non-prod
 * caller also gets the privileged detail and the server stack.
 */
const PillarTableError = () => {
  const { columns, dataQueryError, refetchData, testidTable } =
    usePillarTableContext();

  if (!dataQueryError) {
    return <></>;
  }

  const testid = `${testidTable}-error`;

  return (
    <tr
      className="pillartable-table-row-general bg-neutral-light"
      data-testid={testid}
    >
      <td colSpan={columns.length + 1}>
        <PillarTableErrorMessage error={dataQueryError} testid={testid}>
          {refetchData && (
            <PillarFormLoadingButton
              label="Try Again"
              className="button-regular-neutral-filled"
              testid={`${testid}-retry`}
              onClick={async () => {
                await refetchData();
              }}
            />
          )}
        </PillarTableErrorMessage>
      </td>
    </tr>
  );
};

export default PillarTableError;
